import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import TableData from './TableData'
import FormElement from './FormElement'
import Detail from './Detail'
import { loadBrand, showBrand, deleteBrand, setEdit } from 'Reduxes/inventory/configuration/brand/brandActions'


function Brand() {

    const { data } = useSelector(state => state.brandReducer)
    const dispatch = useDispatch()
    const [content, setContent] = useState('table')
    const [idShow, setIdShow] = useState(null)

    const showDetail = (id) => {
        setIdShow(id);
        setContent('detail')
    }
    const showTable = () => {
        setContent('table');
    }
    const showForm = (type, id) => {
        setIdShow(id);
        setContent('form' + type);
    }

    const renderContent = (contentType) => {
        switch (contentType) {
            case 'table':
                return (<TableData showForm={showForm} showDetail={showDetail} />)
            case 'formNew':
                return (<FormElement type="new" showTable={showTable} />)
            case 'formEdit':
                return (<FormElement rowId={idShow} type="edit" showTable={showTable} />)
            case 'detail':
                return (<Detail showTable={showTable} rowId={idShow} />)
            default:
                return <>Nothing to show here</>
        }
    }

    useEffect(() => {
        dispatch(loadBrand({ all: true }));
    }, [])

    return (
        <>
            {renderContent(content)}
        </>
    )
}

export default Brand